import { computeLayout } from "../lib/tyreLayout";
import { cn } from "../lib/utils";

export default function AxleLayout({ numTyres, vehicleType, positions, onPositionClick }) {
  const axles = computeLayout(numTyres, vehicleType);

  return (
    <div className="inline-block border-2 border-slate-900 bg-white p-6" data-testid="axle-layout">
      {/* Front label */}
      <div className="text-center text-xs font-bold uppercase tracking-widest text-slate-500 mb-2">
        {vehicleType === "truck" ? "Depan" : "Depan Trailer"}
      </div>

      <div className="flex flex-col gap-1">
        {axles.map((axle) => {
          const lefts = axle.positions.filter((p) => p.side === "L").sort((a, b) => a.subIdx - b.subIdx);
          const rights = axle.positions.filter((p) => p.side === "R").sort((a, b) => a.subIdx - b.subIdx);
          return (
            <div key={axle.idx} className="flex items-center gap-1">
              {/* Left tyres */}
              <div className="flex gap-1">
                {lefts.map((p) => (
                  <TyreCell
                    key={p.id}
                    pos={p.id}
                    tyre={positions?.[p.id]}
                    onClick={() => onPositionClick(p.id, positions?.[p.id])}
                  />
                ))}
              </div>
              {/* Axle bar */}
              <div className="flex-1 min-w-[90px] h-10 bg-slate-900 flex items-center justify-center text-white font-mono text-xs">
                AXLE {axle.idx}
              </div>
              {/* Right tyres */}
              <div className="flex gap-1">
                {rights.map((p) => (
                  <TyreCell
                    key={p.id}
                    pos={p.id}
                    tyre={positions?.[p.id]}
                    onClick={() => onPositionClick(p.id, positions?.[p.id])}
                  />
                ))}
              </div>
            </div>
          );
        })}
      </div>

      <div className="text-center text-xs font-bold uppercase tracking-widest text-slate-500 mt-2">Belakang</div>
    </div>
  );
}

function TyreCell({ pos, tyre, onClick }) {
  const filled = !!tyre;
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={`tyre-slot-${pos}`}
      className={cn(
        "tyre-slot w-14 h-24 border-2 flex flex-col items-center justify-center gap-1 rounded-sm",
        filled
          ? "bg-slate-900 border-orange-500 text-white"
          : "bg-white border-dashed border-slate-400 text-slate-400 hover:border-orange-500"
      )}
    >
      <div className="text-[9px] uppercase tracking-widest opacity-70">{pos}</div>
      {filled ? (
        <div className="text-xs font-mono font-semibold leading-tight text-center px-1">
          {tyre.serial_short}
        </div>
      ) : (
        <div className="text-[10px]">kosong</div>
      )}
      {filled && <div className="text-[8px] opacity-60 uppercase truncate w-full px-0.5">{tyre.brand}</div>}
    </button>
  );
}
